var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.currentComponent,{tag:"component",attrs:{"item":_vm.item},on:{"promoteDateil":_vm.promoteDateil,"goback":_vm.goback}})
}
var staticRenderFns = []

export { render, staticRenderFns }